const STORAGE_PREFIX = 'taler.activeLedger'

function keyFor(subject: string): string {
  return `${STORAGE_PREFIX}.${subject}`
}

/** Per signed-in user, so one browser's accounts never see each other's choice. */
export function readStoredActiveLedger(
  subject: string,
  storage: Storage = window.localStorage,
): string | undefined {
  try {
    return storage.getItem(keyFor(subject)) ?? undefined
  } catch {
    return undefined
  }
}

export function storeActiveLedger(
  subject: string,
  ledgerId: string,
  storage: Storage = window.localStorage,
): void {
  try {
    storage.setItem(keyFor(subject), ledgerId)
  } catch {
    // choice simply does not persist
  }
}
